import styled from "styled-components"

const Container = styled.div`
    width: 100%;
    height: 100vh;
    position: sticky;
    top: 0;
    z-index: 1; /* Asegura que se renderice encima de otros elementos */
`

const VideoContainer = styled.img`
    width: 100vw;
    height: 100vh;
    object-fit: cover;
`

export const VideoSection = () => {

    return (

        <Container>

            <VideoContainer
                src={require('../images/img-seccion.webp')}
                alt="Imagen paneles solares"
            />

        </Container>
    )
}

export default VideoSection;